const lsCache = require('lscache')

class Cache {
  /**
   * @param {Number} [flushInterval]=60 - interval in minutes
   */
  constructor(flushInterval = 60) {
    this.lsSupported = false // lsCache.supported()
    this.flushInterval = flushInterval * 60 * 1000 // In milliseconds

    if (!this.lsSupported) {
      this.cache = {}
    } else {
      lsCache.setBucket('sb_')
      this.handleFlush()
    }
  }

  set(key, value, type, time) {
    if (this.lsSupported) {
      lsCache.set(`${type}_${key}`, value, time)
    } else {
      if (!this.cache[type]) {
        this.cache[type] = new Map()
      }

      this.cache[type].set(String(key), value)
    }
  }

  get(key, type) {
    if (this.lsSupported) {
      return lsCache.get(`${type}_${key}`)
    } else {
      return this.cache[type] && this.cache[type].get(String(key))
    }
  }

  handleFlush() {
    const prevFlushTimestamp = lsCache.get('previous_update_time') || Date.now()

    const intervalDiff = this.flushInterval - (Date.now() - prevFlushTimestamp)
    const interval = intervalDiff >= 0 ? intervalDiff : 0

    setTimeout(() => {
      lsCache.flushExpired()
      lsCache.set('previous_update_time', Date.now())

      this.handleFlush()
    }, interval)
  }
}

module.exports = Cache
